export const dataTableInjectionKey = Symbol('dataTable');
